// TODO: Currently this pulls from the global store and instead should get its data from its parent
import React from 'react'
import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { sorts } from '../../app/components/dataTable/withDataTable'
import { isEmptyObject, formatCurrency, formatDate } from '../../common/helpers'

// Components
import DetailsTable from './stateWageDetailsTable'

const StateWageDetailRenderer = ({
  cityData,
  countyData,
  nameColumns,
  noNameColumns,
  stateData,
  federalData
}) => (
  <React.Fragment>
    {federalData ? (
      <React.Fragment>
        <h3>Federal Minimum Wage</h3>
        <DetailsTable columns={noNameColumns} data={federalData} />
      </React.Fragment>
    ) : null}
    {buildStateSection({ stateData, countyData, cityData, federalData, noNameColumns })}
    {Object.keys(countyData).length > 0 ? (
      <React.Fragment>
        <h3>County Minimum Wages</h3>
        <DetailsTable
          columns={nameColumns}
          data={countyData}
          defaultSort={{
            sortBy: 'jurisdictionName',
            direction: 'ASC'
          }}
        />
      </React.Fragment>
    ) : null}

    {Object.keys(cityData).length > 0 ? (
      <React.Fragment>
        <h3>City Minimum Wages</h3>
        <DetailsTable
          columns={nameColumns}
          data={cityData}
          defaultSort={{
            sortBy: 'jurisdictionName',
            direction: 'ASC'
          }}
        />
      </React.Fragment>
    ) : null}
  </React.Fragment>
)

const buildStateSection = ({ stateData, countyData, cityData, federalData, noNameColumns }) => {
  if (!stateData && isEmptyObject(countyData) && isEmptyObject(cityData)) {
    return (
      <React.Fragment>
        <h3>State Minimum Wage</h3>
        <p>
          There is no state or local minimum wage. This state follows the federal minimum wage
          of {formatCurrency(federalData[0].wage)}.
        </p>
      </React.Fragment>
    )
  }
  if (stateData[0]) {
    return (
      <React.Fragment>
        <h3>State Minimum Wage</h3>
        <DetailsTable columns={noNameColumns} data={stateData} />
      </React.Fragment>
    )
  }
  return null
}

const mapStateToProps = (state, ownProps) => {
  const stateData = state.minWage.wagesByJurisdiction[ownProps.country].states[ownProps.state]

  const wages = {
    state: {},
    counties: {},
    cities: {}
  }

  if (stateData) {
    wages.state = stateData.wages['wage rate']

    Object.keys(stateData.cities).map((cityName) => {
      const city = stateData.cities[cityName]
      if (city) {
        wages.cities[cityName] = {
          jurisdictionName: cityName,
          wage: city.wages['wage rate'].wage,
          effectiveDate: formatDate(city.wages['wage rate'].effectiveDate),
          expireDate: formatDate(city.wages['wage rate'].expireDate)
        }
      }
    })

    Object.keys(stateData.counties).map((countyName) => {
      const county = stateData.counties[countyName]
      wages.counties[countyName] = {
        jurisdictionName: countyName,
        wage: county.wages['wage rate'].wage,
        effectiveDate: formatDate(county.wages['wage rate'].effectiveDate),
        expireDate: formatDate(county.wages['wage rate'].expireDate)
      }
    })
  }

  return {
    cityData: wages.cities,
    countyData: wages.counties,
    stateData: !isEmptyObject(wages.state) ? [wages.state] : null,
    // this is stupid, but fixing this component tree will involve more work than there is currently time for
    // todo: burn it all to the ground and rebuild it properly
    federalData: [state.minWage.wagesByJurisdiction.US.wages['wage rate']]
  }
}

const StateWageDetailComponent = compose(
  connect(mapStateToProps),
  withProps((props) => ({
    nameColumns: [
      {
        key: 'jurisdictionName',
        sort: (a, b) => sorts.amount(a.jurisdictionName, b.jurisdictionName),
        text: 'Name',
        width: 3000
      },
      {
        key: 'wage',
        sort: (a, b) => sorts.amount(a.wage, b.wage),
        text: 'Amount',
        width: 3000
      },
      {
        key: 'effectiveDate',
        sort: (a, b) => sorts.amount(a.effectiveDate, b.effectiveDate),
        text: 'Effective',
        width: 3000
      },
      {
        key: 'expireDate',
        sort: (a, b) => sorts.amount(a.expireDate, b.expireDate),
        text: 'Expires',
        width: 3000
      }
    ],
    noNameColumns: [
      {
        key: 'wage',
        sort: (a, b) => sorts.amount(a.wage, b.wage),
        text: 'Amount',
        width: 3000
      },
      {
        key: 'effectiveDate',
        sort: (a, b) => sorts.amount(a.effectiveDate, b.effectiveDate),
        text: 'Effective',
        width: 3000
      },
      {
        key: 'expireDate',
        sort: (a, b) => sorts.amount(a.expireDate, b.expireDate),
        text: 'Expires',
        width: 3000
      }
    ]
  }))
)(StateWageDetailRenderer)

export default StateWageDetailComponent
